<script>
    import SideLink from '../../components/SidepanelLink/SidepanelLink.svelte'
    
    export let clientId
</script>

<style>
    /* your styles go here */
</style>

<SideLink url="/app/clients" label="Lista clienti" />
<SideLink url="/app/clients/{clientId}/details" label="Informazioni" />
<SideLink url="/app/clients/{clientId}/logs" label="Timeline" />
<SideLink url="/app/clients/{clientId}/alerts" label="Alert" />